export default "/img/DK.17e8bbf0fd795b79352e9760b3cf19c8.png";